import { FilterSelectionOption } from '../models';

export function sortItemsBySelection<T>(
  selectedValues: T[],
  allItems: FilterSelectionOption<T>[],
): FilterSelectionOption<T>[] {
  if (!selectedValues.length) {
    return allItems;
  }

  const selectedValuesSet: Set<T> = new Set(selectedValues);

  return [...allItems].sort((item1, item2) => {
    if (selectedValuesSet.has(item1.value) && !selectedValuesSet.has(item2.value)) {
      return -1;
    }

    if (!selectedValuesSet.has(item1.value) && selectedValuesSet.has(item2.value)) {
      return 1;
    }

    return 0;
  });
}
